import {memo, useEffect, useMemo, useState} from "react";
import {useSelector} from "react-redux";
import s from "./docs.module.css";
import SaveStatus from "../../UIComponents/SaveStatus";
import {Button} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import PostAddIcon from "@mui/icons-material/PostAdd";

import ModalDialog from "../../UIComponents/ModalDialog";
import GeoIconArray from "../GeoIconArray";

import useStyles from "./useStyles";
import useStylesReactTable from "../../StylizedComponents/StylizedMaterialReactTable/useStyles";

import mapStateToProps from "./mapStateToProps";
import Box from "@mui/material/Box";
import Pencil from "../../icons/Pencil";
import BasketSvg from "../../icons/BasketSvg";
import StylizedMaterialReactTable from "../../StylizedComponents/StylizedMaterialReactTable";
import theme from "../App/theme";
import {dialogTypes} from "../../UIComponents/ModalDialog/ModalDialog";
import DirectoryList from "../DirectoryList";
import {BURGER_MENU_LIST} from "../BurgerMenusToggler/constants";
import DirectoryBurgerMenuShowButton from "../DirectoryBurgerMenusToggler";
import Plus from "../../icons/Plus";

const DirectoryBody = (props) => {
  const {
    fields = [],
    label,
    update,
    rightCheker,
    directoryData,
    dictId,
  } = props;

  const {
    savingDirectory,
    addingDirectory,
    deletingDirectory,

    saveDirectory = () => {},
    addDirectory = () => {},
    deleteDirectory = () => {},
    burgerMenuOpened,
  } = useSelector(mapStateToProps);

  const classes = useStyles();
  const classesReactTable = useStylesReactTable();

  const [rows, setRows] = useState([]);

  const [editedId, setEditedId] = useState(0);

  const [showEditDialog, setShowEditDialog] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showAddDialog, setShowAddDialog] = useState(false);

  const hasEditActions = rightCheker("edit");
  const hasDeleteAction = rightCheker("delete");
  const hasActions = hasEditActions || hasDeleteAction;

  const { data = [] } = directoryData || {};

  const rowCreator = () => {

    const renderableTypes = ["icon", "Color", "color"];

    try {
      const tmpRows = data.map((rowOriginals, i) => {
        const rowResult = {};
        fields.forEach((val, j) => {
          console.log("val", i, j, val);
          if (val?.type && renderableTypes.includes(val.type)) {
            rowResult[val.name] = rowOriginals[j]?.rawValue;
            // rowResult[val.name]=(
            //     <GeoIconArray iconNum={rowOriginals[j]?.rawValue} />
            // )
            // }else if(val?.type==='Color' || val?.type==='color' ){
            //     rowResult[val.name]=(
            //         <><div className={classes.colorBox} style={{color:rowOriginals[j]?.rawValue}}/> {rowOriginals[j]?.rawValue}</>
            //     )
          } else {
            rowResult[val.name] = rowOriginals[j]?.value;
          }
          if (val.isId && val.name !== "id")
            rowResult.id = rowOriginals[j]?.value;
        });
        if (hasActions) rowResult.___actions = i;
        return rowResult;
      });
      setRows(tmpRows);
    } catch (error) {
      setRows([]);
      return;
    }
  };

  const rawTable = data.map((row) => row.map((cell) => cell?.rawValue));

  const sDeleteConfirm = (id) => {
    setEditedId(id);
    setShowDeleteDialog(true);
  };
  const sEditDialog = (id) => {
    setEditedId(id);
    setShowEditDialog(true);
  };
  const sAddDialog = (id) => {
    setEditedId(id);
    setShowAddDialog(true);
  };
  const hideDialog = () => {
    setShowEditDialog(false);
    setShowDeleteDialog(false);
    setShowAddDialog(false);
  };

  const actionsCreator = {
    field: "___actions",
    headerName: "Операции",
    accessorKey: "Операции",
    header: "___actions",
    sortable: false,
    width: 250,
    renderCell: ({ value }) => {
      return (
          <>
            <Button
                variant="contained"
                size="small"
                color="error"
                startIcon={<DeleteIcon />}
                onClick={() => sDeleteConfirm(value)}
                style={{ marginLeft: 4 }}
                disabled={!hasDeleteAction}
            >
              Удалить
            </Button>
            <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={() => sEditDialog(value)}
                startIcon={<ModeEditIcon />}
                style={{ marginLeft: 4 }}
                disabled={!hasEditActions}
            >
              Изменить
            </Button>
          </>
      );
    },
  };

  useEffect(() => {
    if (
        directoryData?.data &&
        !directoryData?.loading &&
        !directoryData?.error
    ) {
      rowCreator();
    } else if (directoryData?.loading || directoryData?.error) {
      setRows([]);
    }
  }, [directoryData]);

  const dataAdd = (fields) => {
    addDirectory({
      dictId,
      fields,
    });
  };
  const dataSave = (fields) => {
    let id = getId(data);
    saveDirectory({
      dictId,
      id,
      fields,
    });
  };
  const dataDelete = (index) => {
    let id = getId(rows[index]);
    deleteDirectory({
      dictId,
      id,
    });
  };

  const getId = (data) => {
    for (let item of fields) {
      if (item.isId && item.name) return data?.[item.name];
    }
    return undefined;
  };
  const columns = fields.map(({ label, name, type }, i) => {
    const tmpResult = {
      field: name,
      headerName: label,
      width: label.length * 8 + 33,
      size: name === "rec_id" ? 120 : label.length * 8 + 33,
      accessorKey: name,
      header: label,
      muiTableHeadCellProps: {
        className: name === "rec_id" ? classesReactTable.fieldN : "",
      },
    };

    if (type === "icon") {
      tmpResult.renderCell = ({ value }) => <GeoIconArray iconNum={value} />;
    } else if (type === "color" || type === "Color") {
      tmpResult.renderCell = ({ value }) => (
          <>
            <div className={classes.colorBox} style={{ backgroundColor: value }}>
              &nbsp;
            </div>
          </>
      );
      tmpResult.width = 90;
    }
    return tmpResult;
  });

  const rootData = useMemo(() => rows.filter((r) => !r.parent_rec_id), [rows]);

  const tablesStylesOptions = {
    tableCell: {
      minWidth: `calc(98% / ${columns.length + 2})`,
    },
  };

  const tableOptions = {
    getSubRows: (row) => rows.filter((r) => r.parent_rec_id === row.rec_id),
    columns,
    data: rootData,

    //optionally override the default column widths
    defaultColumn: {
      //maxSize: 400,
      //minSize: 80,
      //size: 160, //default size is usually 180
    },
    enableStickyHeader: true,
    enableColumnResizing: true,
    enableColumnOrdering: true,
    columnResizeMode: "onChange", //default
    enableFullScreenToggle: false,
    enableExpanding: true,
    filterFromLeafRows: true, //apply filtering to all rows instead of just parent rows
    initialState: { expanded: true }, //all rows expanded by default
    positionPagination: "top",

    enableRowActions: !!hasActions,
    positionActionsColumn: "last",

    // свойства строк !!!
    muiTableBodyRowProps: ({ row }) => ({
      className: row.subRows?.length
          ? classesReactTable.parentRow
          : classesReactTable.childrenRow,
      itemProp: row.depth,
    }),
    // свойства ячейки !!!
    muiTableBodyCellProps: ({ cell }) => ({
      // включаем также поле со стрелкой свернуть/развернуть !!!
      itemProp: ["rec_id", "mrt-row-expand"].includes(cell.column.id)
          ? cell.row.depth
          : "",
    }),

    renderRowActions: ({ row }) => (
        <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
          <Button
              disabled={!hasDeleteAction}
              onClick={() => sDeleteConfirm(row.original.___actions)}
          >
            <BasketSvg fill={theme.palette.mainButton.red} />
          </Button>
          <Button
              disabled={!hasEditActions}
              onClick={() => {
                sEditDialog(row.original.___actions);
              }}
          >
            <Pencil />
          </Button>
        </Box>
    ),
  };

  return (
      <div className={s.docsContainer} style={{ width: "100%" }}>
        {showAddDialog ? (
            <ModalDialog
                key="edit_dialog"
                update={update}
                saver={dataAdd}
                onClose={hideDialog}
                dictId={dictId}
                open={true}
                okText="Добавить"
                formFieldsValues={rawTable?.[editedId]}
                formFields={fields}
                okIcon={<PostAddIcon />}
                title="Добавление записи"
                progressObj={addingDirectory}
            />
        ) : null}

        {burgerMenuOpened?.name === BURGER_MENU_LIST.DIRECTORY && (
            <div className={classes.mobileMenu}>
              <DirectoryList />
            </div>
        )}

        {showEditDialog ? (
            <ModalDialog
                key="edit_dialog"
                update={update}
                onClose={hideDialog}
                dictId={dictId}
                open={true}
                okText="Сохранить"
                formFieldsValues={rawTable?.[editedId]}
                formFields={fields}
                saver={dataSave}
                progressObj={savingDirectory}
                okIcon={<ModeEditIcon />}
                title="Изменение записи"
            />
        ) : null}

        {showDeleteDialog ? (
            <ModalDialog
                key="edit_dialog"
                update={() => {
                  setRows(rows.filter((_foo, i) => i !== editedId));
                }}
                onClose={hideDialog}
                dictId={dictId}
                open={true}
                okColor="error"
                okText="Удалить"
                // formFieldsValues={rawTable?.[editedId]}
                // formFields={fields}
                itemIndex={editedId}
                saver={dataDelete}
                progressObj={deletingDirectory}
                okIcon={<DeleteIcon />}
                title="Подтвердите удаление"
                type={dialogTypes.DELETE}
            />
        ) : null}
        {/*<div className={s.secondRightConrainer}>
                <div className={s.contentContainer}>
                    <Typography variant='h3'>{label}</Typography>
                </div>
            </div>*/}
        {directoryData?.loading && (
            <div className={s.secondRightConrainer}>
              <div className={s.contentContainer}>
                <SaveStatus
                    errShowTime={1000}
                    successShowTime={500}
                    dataObj={directoryData}
                    title="Загрузка данных справочника"
                />
              </div>
            </div>
        )}

        {!directoryData?.loading && (
            <div className={s.secondRightConrainer}>
              <div className={s.contentContainer}>
                <div className={classes.buttonsContainer}>

                  <DirectoryBurgerMenuShowButton />

                  {(rightCheker('create')) ? (
                      <>
                        <Button
                            onClick={()=> sAddDialog()}
                            variant="contained"
                            size="small"
                            color='primary'
                            startIcon={<Plus color={'white'} />}
                            className={classes.buttonAdd}
                        >
                          Добавить
                        </Button>
                        <div className={classes.directoryName}>{label}</div>
                      </>

                  ) : null }
                </div>
              </div>
            </div>
        )}


        <div className={s.secondRightConrainer}>
          <div className={s.contentContainer}>
            {!directoryData?.loading ? (
                <StylizedMaterialReactTable
                    tableOptions={tableOptions}
                    tablesStylesOptions={tablesStylesOptions}
                />
            ) : null}
          </div>
          {/* <BodyRight /> */}
        </div>
      </div>
  );
};

export default memo(DirectoryBody);
